export default "15c27ebd375da340.svg"